import { useContext, useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ModalManagementStore } from '../../providers/modal-manager';
import Button from '../../components/Button';
import GenericCard from '../../components/GenericCards/GenericCards';
import Pager from '../../components/Pager';
import Chip from '../../components/TransactionStatus/Chip';
import Link from '../../components/Link';

import {
  TransactionHistoryStore,
  TransactionHistoryProvider,
} from '../../providers/documentCenter';

function TableData() {
  const [currPage, setCurrPage] = useState(1);
  const { documentCenter } = useContext(TransactionHistoryStore);
  const { openModal } = useContext(ModalManagementStore);

  return (
    <Container className={'cnd-custom-container px-0 mt-11'}>
      <Container className={'px-7 px-lg-0 mb-7 mb-lg-7'}>
        <Row>
          <Col className={'col-8 col-lg-4'}>
            <h2 className={'text-sm-20-lg-24 mb-7 mb-lg-11'}>
              Document Center
            </h2>
          </Col>
          <Col className={'col-4 col-lg-8 d-flex justify-content-end '}>
              <Button onClick={() => openModal('document-upload')} className={'mb-7 mb-lg-11'}>Upload</Button>
          </Col>
        </Row>
        <Row>
          <Col className={'col-12'}>
              <p className="text-caption lh-xs">
                Personalized documents and uploaded materials are available for display for 18 months. Review Resources section for PDFs and other materials.
                <br /><br />
                In some cases, certified copies of documents will be required before processing can be completed. This is necessary for: spousal consent (due to the notary stamp), birth certificates (due to raised seal) and marriage certificates (due to raised seal). Please provide a certified copy of these documents via postal or overnight mail after uploading the document.
             </p>
          </Col>
        </Row>

      </Container>
      <GenericCard variant={'white'}>
        <Row>
          <Col>
            <Row className={'d-none d-lg-flex border-bottom-dark-gray py-8'}>
              <Col className={'d-none d-lg-block col-lg-1 text-fs-6 m-0'}>
                Submitted
              </Col>
              <Col className={'col-lg-2 ps-6 m-0'}>
                <span className={'text-fs-6 ms-11'}>From</span>
              </Col>
              <Col className={'col-auto col-1 col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Action</span>
              </Col>
              <Col className={'col-auto col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Category</span>
              </Col>
              <Col className={'col-lg-1 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Topic</span>
              </Col>
              <Col className={'col-auto col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Note</span>
              </Col>
              <Col className={'col-auto col-lg-1 text-fs-6 m-0 text-end'}>
                <span className={'text-fs-6'}>Status</span>
              </Col>
              <Col className={'col-auto col-lg-1 text-fs-6 m-0 text-end'}>
                <span className={'text-fs-6'}></span>
              </Col>
            </Row>
            {documentCenter.map((transaction, index) => {
              return (
                <Row className={'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'}
                key={index}>
                  <Col className={'px-0 px-lg-5 col-3 col-lg-1 order-0'}>
                    <span className={'text-blue h3 text-fs-6 m-0'}>
                      {transaction['submitted']}
                    </span>
                  </Col>
                  <Col className={'col-3 col-lg-2 d-lg-flex align-items-start justify-content-lg-center order-1'}>
                    <span className={'d-flex align-items-center h3 text-fs-6 m-0'}>
                      {transaction['from']}
                    </span>
                  </Col>
                  <Col className={'ms-auto m-lg-0 col-auto col-lg-1 order-2 order-lg-5'}>
                    <div>
                      <Chip variant={transaction['status']} />
                    </div>
                  </Col>
                  <Col className={'d-flex d-lg-block align-items-center col-12 col-lg-2 order-3 py-6 px-5 mt-7 mt-lg-0 py-lg-0'}>
                    <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                      Action
                    </h2>
                    <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                      {transaction['action']}
                    </span>
                  </Col>
                  <Col className={'d-flex d-lg-block align-items-center col-12 col-lg-2 order-4 order-lg-3 py-6 px-5 py-lg-0'}>
                    <h2 className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}>
                      Category
                    </h2>
                    <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                      {transaction['category']}
                    </span>
                  </Col>
                  <Col className={'d-flex d-lg-block align-items-center col-12 col-lg-1 order-5 order-lg-4 py-6 px-5 py-lg-0'}>
                    <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                      Topic
                    </h2>
                    <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                      {transaction['topic']}
                    </span>
                  </Col>
                  <Col className={'d-flex d-lg-block align-items-center col-12 col-lg-2 order-5 order-lg-4 py-6 px-5 py-lg-0'}>
                    <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                      Note
                    </h2>
                    <span className={'w-100 text-end text-lg-start h3 text-fs-6 m-0'}>
                      {transaction['note']}
                    </span>
                  </Col>
                  <Col className={'d-flex d-lg-block align-items-center justify-content-center col-12 col-lg-1 order-5 order-lg-6 py-6 px-5 py-lg-0'}>
                    <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                      
                    </h2>
                    <span className={'w-100 text-end text-lg-center h3 text-fs-6 m-0'}>
                       <Link
                          className={'text-decoration-none'}
                          href={`${
                            process.env.PUBLIC_URL
                          }/${transaction['url']}`}
                          target={'_blank'}
                        >
                          <Button
                            className="wealth-compensation-btn w-100 mx-5 mx-lg-0 px-5"
                            variant="primary"
                            size="sm"
                          >
                            View
                          </Button>
                        </Link>
                        
                    </span>
                  </Col>
                </Row>
              );
            })}
          </Col>
        </Row>
        <Container
          className={
            'px-0 mt-11 d-flex d-lg-block justify-content-center mt-11 mt-lg-10'
          }
        >
          <Pager
            pagesSize={3}
            currentPage={currPage}
            onPageChange={setCurrPage}
          />
        </Container>
      </GenericCard>
    </Container>
  );
}

const DocumentCenter = () => {
  return (
    <TransactionHistoryProvider>
      <TableData />
    </TransactionHistoryProvider>
  );
};

export default DocumentCenter;
